import { connect } from 'react-redux';
import { VOD, WATCH, TRENDING } from 'app-source/routes/types';
import { redirect } from 'redux-first-router';
import { selectors } from 'app-webtech-core';
import { HeaderComponent } from '../components/Header';
import { checkMobileOperatingSystem } from '../utils/checkMobileOperatingSystem';
import { IsUserAccountEnabledSelector } from '../selectors/isUserAccountEnabled';
import { sectionSelect } from '../utils/sectionSelect';
import { playViralClip, changeViralUrlSlug } from 'app-modules/viral/actions';

const mapStateToProps = (state, ownProps) => {
  const { isFullscreen, content } = selectors.player.properties(state);
  const { isIos, isAndroid } = checkMobileOperatingSystem();
  const isMobile = isIos || isAndroid;
  return {
    isFullscreen,
    content,
    isMobile,
    page: state.page,
    displayTabsAndUserAccount: !selectors.location.isPageNotFound(state),
    enableVOD: selectors.application.enableVOD(state),
    isUserAccountEnabled: IsUserAccountEnabledSelector(state),
    locationType: selectors.location.properties(state).type,
    prevLocation: selectors.location.properties(state).prev.type,
  };
};

const mapDispatchToProps = (dispatch) => ({
  redirectToWatch: () => sectionSelect(dispatch, WATCH),
  redirectToVod: () => sectionSelect(dispatch, VOD),
  redirectToTrending: () => dispatch(redirect({ type: TRENDING })),
  redirectToViral: (content) => {
    dispatch(playViralClip({ id: content.id, slug: content.slug }));
    dispatch(changeViralUrlSlug(content.slug));
  },
});

const mergeProps = (
  { locationType, prevLocation, content, ...stateProps },
  dispatchProps,
  ownProps,
) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  redirectToWatch: () => {
    if (prevLocation === 'PAGE_VIRAL_CLIP_ITEM') {
      dispatchProps.redirectToViral(content);
    } else if (locationType !== 'PAGE_WATCH_CHANNEL') {
      dispatchProps.redirectToWatch();
    }
  },
});

export const Header = connect(mapStateToProps, mapDispatchToProps, mergeProps)(HeaderComponent);
